import { cn } from '@/lib/utils';

const Video = ({
    src,
    className,
    poster,
}: {
    src: string;
    className?: string;
    poster?: string;
}) => {
    return (
        <video
            width="1280"
            height="720"
            preload="none"
            loop
            muted
            autoPlay
            poster={poster ?? '/images/logo.svg'}
            playsInline
            className={cn('w-full h-auto md:h-full', className)}
        >
            <source src={src} type="video/webm" />
            Your browser does not support the video tag.
        </video>
    );
};

export default Video;
